export const Roles = {
  administrator: 1,
  delegation: 2,
  story_brand: 3,
  story_dealer: 4,
  can_errors: 5,
  mileage: 6,
  installs: 7,
  spec_brand: 9,
  spec_dealer: 10,
  moderation: 11,
  tradein: 13,
  areas: 14,
  dealers_areas: 15,
  upload_exhibition_data: 16,
  russified_cars: 17,
};

export default Roles;
